export const getSectionById = (state, getters) => (id) => { 
	return state.home.sections.find( section => {
		return (section.id === id)
	})
}